import { motion } from "framer-motion";

/**
 * Shimmer skeleton block. Uses a moving gradient overlay for a polished
 * loading effect. Themed via design tokens so it works in light/dark.
 */
function Bar({ className = "" }: { className?: string }) {
  return (
    <div className={`relative overflow-hidden rounded-md bg-muted/70 ${className}`}>
      <motion.div
        initial={{ x: "-100%" }}
        animate={{ x: "100%" }}
        transition={{ duration: 1.4, repeat: Infinity, ease: "linear" }}
        className="absolute inset-y-0 w-1/2 bg-gradient-to-r from-transparent via-foreground/10 to-transparent"
      />
    </div>
  );
}

/** Skeleton for the form-panel content area inside AuthShell. */
export function AuthFormSkeleton() {
  return (
    <div aria-busy="true" aria-live="polite" className="space-y-5">
      {/* Step indicator skeleton */}
      <div className="mb-6 flex items-end justify-between">
        <Bar className="h-14 w-24" />
        <div className="flex flex-1 items-center justify-end gap-1.5 ps-4">
          <Bar className="h-1.5 w-8" />
          <Bar className="h-1.5 w-4" />
          <Bar className="h-1.5 w-4" />
        </div>
      </div>

      {/* Heading skeletons */}
      <Bar className="h-5 w-28" />
      <Bar className="h-9 w-3/4" />
      <Bar className="h-4 w-5/6" />
      <Bar className="h-4 w-2/3" />

      {/* Inputs */}
      <div className="space-y-3 pt-4">
        <Bar className="h-4 w-24" />
        <Bar className="h-14 w-full" />
        <Bar className="h-3 w-1/2" />
      </div>

      {/* Primary CTA */}
      <Bar className="h-12 w-full" />

      {/* Secondary line */}
      <div className="flex items-center justify-between pt-2">
        <Bar className="h-3 w-24" />
        <Bar className="h-3 w-16" />
      </div>

      {/* Footer line */}
      <div className="mt-10 flex items-center justify-between border-t border-border/60 pt-4">
        <Bar className="h-3 w-24" />
        <Bar className="h-3 w-32" />
      </div>

      <span className="sr-only">در حال بارگذاری…</span>
    </div>
  );
}

export default AuthFormSkeleton;
